import { Paragraph } from '@eggplant/pattern-library'

const MyAccount = () =>
  <Paragraph>
    Here is where you can manage all your account settings.
  </Paragraph>

export default MyAccount
